import React from "react";
import { FormContext } from "./form-context";
import * as mapping from "../mapping/flat";

const form = Component =>
  function FormComponent(props) {
    const {
      initial = {},
      values = {},
      getValue = mapping.getValue,
      setValue = mapping.setValue,
      onChange = () => {},
      onValues = () => {},
      errors = {}
    } = props || {};

    return (
      <FormContext.Provider
        value={{
          form: {
            state: initial,
            errors,
            onChange,
            updateValue: obj => onValues(setValue(values, obj)),
            getValue: name => getValue(initial, name)
          }
        }}
      >
        <Component {...props} />
      </FormContext.Provider>
    );
  };

export default form;
